import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import config from "../config";

const useStudentData = () => {
  const [rollNo, setRollNo] = useState("");
  const [studentData, setStudentData] = useState(null);
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const rollNoInputRef = useRef(null);

  useEffect(() => {
    rollNoInputRef.current?.focus(); // Set focus on page load
  }, []);

  const movetodashboard = (e) => {
    e.preventDefault();
    navigate("/dashboard");
  };

  const fetchStudentData = async () => {
    const token = localStorage.getItem("token");
    const centCode = localStorage.getItem("CentCode");

    if (!token) {
      Swal.fire({
        icon: "warning",
        title: "Authentication Required",
        text: "Authentication token is missing. Please log in.",
      });
      navigate("/");
      return;
    }
    if (!/^\d{5}$/.test(rollNo)) {
      Swal.fire({
        icon: "error",
        title: "Please enter 5 digits valid roll no.",
        text: "",
      });
      return;
    }

    setLoading(true);
    setIsSearchClicked(true);

    try {
      const response = await axios.post(
        `${config.API_BASE_URL}/Auth/GetSSLREG_BySchoolCode`,
        { ROLL_NO: rollNo, CENT_CODE: centCode },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("API Response:", response);

      const responseData = response.data.data;
      //  console.log(responseData);
      if (response.data.status === 200) {
        if (responseData.STAT === "1") {
          console.log("Data Found (STAT = 1)");

          const studentInfo = responseData.school_data[0]; 
          setStudentData(studentInfo);
          console.log(studentInfo);
          setTimeout(() => {
            document.querySelectorAll(".personal-details, .other-details, .subject-details, .result, .resultbutton").forEach(el => {
              el.style.display = "block";
            });
          }, 100);
        } 
        else if (responseData.STAT === "0") {
          console.log("No Data Available (STAT = 0)");
          Swal.fire({
            icon: "error",
            title: "The student is already registered.",
          });

          setStudentData(null);
          document.querySelectorAll(".personal-details, .other-details, .subject-details, .result, .resultbutton")
            .forEach(el => el.style.display = "none");
        } 
        else {
          console.error("Unexpected Response:", response.data);
        }
      } 
      else {
        Swal.fire({
          icon: "info",
          title: "No Data Found",
          text: "No student data found for the given Roll No.",
        });

        setStudentData(null);
        document.querySelectorAll(".personal-details, .other-details, .subject-details, .result, .resultbutton")
          .forEach(el => el.style.display = "none");
      }
    } catch (error) {
      console.error("Error fetching student data:", error);
      Swal.fire({
        icon: "warning",
        title: "Invalid Roll No.",
      });
      setStudentData(null);
      setIsSearchClicked(false);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    window.location.reload();
  };

  return {
    rollNo,
    setRollNo,
    studentData,
    isSearchClicked,
    loading,
    setLoading,
    rollNoInputRef,
    movetodashboard,
    fetchStudentData,
    handleReset,
  };
};

export default useStudentData;
